import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ISlaTimerEvent, ISlaTimerSyncEvent, ISlaTimerSyncResponse, SlaTimerAction } from '../../models/sla-timer.model';

@Injectable({ providedIn: 'root' })
export class SLATimerService {

  private slaTimerSubject = new Subject<ISlaTimerEvent>();
  private slaTimerSyncSubject = new Subject<ISlaTimerSyncEvent>();

  slaTimer$ = this.slaTimerSubject.asObservable();
  slaTimerSync$ = this.slaTimerSyncSubject.asObservable();

  triggerSlaTimer(approvalRequestId: string, action: SlaTimerAction) {
    this.slaTimerSubject.next({ approvalRequestId, action: action });
  }

  triggerSlaTimerSyncRequest(approvalRequestId: string) {
    this.slaTimerSyncSubject.next({ type: 'REQUEST', approvalRequestId });
  }

  triggerSlaTimerSyncResponse(data: ISlaTimerSyncResponse) {
    this.slaTimerSyncSubject.next({ type: 'RESPONSE', ...data });
  }
}
